import MedicineDictionary from '@/entities/medicine-dictionary/model/medicineDictionary.model';
import { PopularMedicineDictionaryItemsQuery } from '@/types/bff/gql-schema';
import { QueryClient } from '@tanstack/react-query';
import { usePopularMedicineDictionaryItemsQuery } from './medicine-dictionary.gql.impl';

const parsePopularMedicineDictionaryItems = (data: PopularMedicineDictionaryItemsQuery) => {
  return data.popularMedicineDictionaryItems.map((item) => {
    return new MedicineDictionary({
      id: item.id,
      publicId: item.publicId,
      basicInfo: {
        name: item.basicInfo.name,
        simplifiedName: item.basicInfo.simplifiedName,
        pharmaceuticalEffectLiteracy: item.basicInfo.pharmaceuticalEffectLiteracy,
        medicineImage: item.basicInfo.medicineImage ?? undefined,
      },
      medicineGuide: {
        wholeSummary: item.medicineGuide.wholeSummary.join(' '),
      },
      packagingInfo: {
        image: item.packagingInfo.image ?? undefined,
      },
    });
  });
};

const usePopularMedicineDictionaryItems = () => {
  const { data: popularMedicineDictionaryItems, isLoading: isPopularMedicineDictionaryItemsLoading } =
    usePopularMedicineDictionaryItemsQuery(
      {},
      {
        select: parsePopularMedicineDictionaryItems,
        staleTime: 1000 * 60 * 5, // 5분 - SSR과 동일한 설정
      }
    );
  return {
    popularMedicineDictionaryItems,
    isPopularMedicineDictionaryItemsLoading,
  };
};

usePopularMedicineDictionaryItems.prefetchQuery = async (queryClient: QueryClient) => {
  return queryClient.prefetchQuery({
    queryKey: usePopularMedicineDictionaryItemsQuery.getKey({}),
    queryFn: usePopularMedicineDictionaryItemsQuery.fetcher({}),
    staleTime: 1000 * 60 * 5, // 5분
  });
};

export default usePopularMedicineDictionaryItems;
